module.exports = __webpack_public_path__ + "assets/img/test.fb6195c7.png";